import React, { useState } from "react";
import { TopButs } from "./TopButs";
import { Content } from "./Content";
import { useFiltrationModel } from "../../filtrationModel";

export const FiltrationDetails = () => {
	const { filtrationOne } = useFiltrationModel();

	return (
		<>
			{filtrationOne[0]?.id && <>
				<TopButs />
				<Content />
			</>
			}
		</>
	)
}